import LoveRobotSvg from '@/assets/LoveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { ThankfulMessageProps } from '@/components/welcomeAgainPage/ThankfulMessageDesktop.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import React from 'react';

const ThankfulMessageMobile: React.FC<ThankfulMessageProps> = ({
  buttonLabel,
  handleClick,
  message,
  title,
}) => {
  return (
    <div className="flex flex-column w-full">
      <DialogMobile
        content={message}
        image={
          <img
            alt="love-robot"
            className="object-cover w-75 align-self-end"
            src={generateNonCachableImageSrc(LoveRobotSvg)}
          />
        }
        message={title}
      />
      <ButtonWithLoading onClick={handleClick}>{buttonLabel}</ButtonWithLoading>
    </div>
  );
};

export default ThankfulMessageMobile;
